// LoadingSpinnerContext.js

import React, { createContext, useContext, useState } from 'react';
import LoadingSpinner from './loading-spinner'; // Adjust the import path





/*************************************
  USAGE
  import { useLoadingSpinner } from 'contexts/loading-spinner/loading-spinner-context';
  const { showLoadingSpinner, hideLoadingSpinner } = useLoadingSpinner();

  showLoadingSpinner();
  onError: hideLoadingSpinner
**************************************/




const LoadingSpinnerContext = createContext();

export const LoadingSpinnerProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState();
  const [bgOpacity, setBgOpacity] = useState();

  const showLoadingSpinner = (text='Cargando información', bgOpacity=0) => 
  {
    setLoading(true);
    setText(text);
    setBgOpacity(bgOpacity);
  };

  const hideLoadingSpinner = () => 
  {
      setLoading(false);
  };

  return (
    <LoadingSpinnerContext.Provider value={{ showLoadingSpinner, hideLoadingSpinner }}>
      {children}
      {loading && <LoadingSpinner text={text} bgOpacity={bgOpacity}/>}
    </LoadingSpinnerContext.Provider>
  );
};

export const useLoadingSpinner = () => {
  const contextLoadingSpinner = useContext(LoadingSpinnerContext);
  if (!contextLoadingSpinner) {
    throw new Error('useLoadingSpinner must be used within a LoadingSpinnerProvider');
  }
  return contextLoadingSpinner;
};
